import { render, staticRenderFns } from "./linXunRegister.vue?vue&type=template&id=7b9e9ff8&"
import script from "./linXunRegister.vue?vue&type=script&lang=js&"
export * from "./linXunRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports